store.admin.languages = [];
store.admin.initLang = function() {
	var parentSel = (arguments.length == 1) ? arguments[0] : '#store';
	$(parentSel + ' ul.langPicker li').each(function(){
		$(this).css('cursor','pointer');
		$(this).click(function(){
			store.admin.switchLang($(this).attr('rel'), parentSel);
		});
	});
};
store.admin.switchLang = function (lang) {
	var parentSel = (arguments.length == 2) ? arguments[1] : '#store';
	$(parentSel+' .lang_wrapper').hide().removeClass('selected');
	$(parentSel+' .lang_wrapper .lang').removeClass('selected');

	var wrapper = $(parentSel+' .lang_wrapper_' + lang);
	//wrapper.fadeIn("slow");
	wrapper.show().addClass('selected');
	var wrapperInput = $(parentSel+' .lang_wrapper_' + lang + " .lang");
	wrapperInput.addClass('selected');

	var sel = parentSel+' ul.langPicker li.'+lang + ' img';
	var src = $(sel).attr('src');
	$(parentSel+' ul.langPicker li').removeClass('selected');
	$(parentSel+' ul.langPicker li.'+lang).addClass('selected');
	$(parentSel+' ul.langPicker').data('current', lang);

	return false;
};
